import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';

import '../../assets/scss/index.scss';

const LinkComponent = ({
  title,
  onClick = () => {},
  className = '',
  ...props
}) => (
  <Button
    className={className}
    type="link"
    onClick={onClick}
    {...props}
  >
    {title}
  </Button>
);

LinkComponent.propTypes = {
  title: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string,
};

export default memo(LinkComponent);